import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AgreementGate({ children }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    // Gate broker company users (owner + brokers) on the platform agreement
    if (['owner', 'broker'].includes(user.role) && user.brokerCompanyId) {
      const checkBroker = async () => {
        try {
          const token = localStorage.getItem('token');
          const res = await fetch('/api/subscription/agreement', {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (!res.ok) { setChecking(false); return; }
          const data = await res.json();
          if (data.agreement && !data.accepted) {
            navigate('/broker-agreement', { replace: true });
            return;
          }
          setChecking(false);
        } catch (err) {
          console.error('Broker gate check failed:', err);
          setChecking(false);
        }
      };
      checkBroker();
      return;
    }

    // Only gate introducers below
    if (user.role !== 'introducer') {
      setChecking(false);
      return;
    }

    const check = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch('/api/agreements/me', {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();

        if (data.status === 'unsigned') {
          // No agreement yet — send to agreement page
          if (data.inviteToken) {
            navigate(`/agreement/${data.inviteToken}`, { replace: true });
          } else {
            // No invite token found — show pending
            navigate('/pending-review', { replace: true });
          }
          return;
        }

        if (['pending', 'countersigned', 'with_compliance'].includes(data.status)) {
          // Submitted but not yet fully approved — the countersign and
          // network-compliance stages still count as "under review"
          navigate('/pending-review', { replace: true });
          return;
        }

        if (data.status === 'rejected') {
          // Rejected — log out and show message
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('user');
          navigate('/login?rejected=1', { replace: true });
          return;
        }

        // approved — let through
        setChecking(false);
      } catch (err) {
        console.error('Gate check failed:', err);
        setChecking(false);
      }
    };

    check();
  }, []);

  if (checking) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 32, marginBottom: 16 }}>🔐</div>
          <p style={{ color: '#6b7280', fontSize: 15 }}>Checking your account status...</p>
        </div>
      </div>
    );
  }

  return children;
}
